/** "Raise a ticket" is a mail link to the group helpdesk, not a feature; hidden when the group set no address. */
export function HelpdeskLink({ email, subject = "Help with a document" }: { email: string | null; subject?: string }) {
  if (!email) return null;
  return (
    <a className="link" href={`mailto:${email}?subject=${encodeURIComponent(subject)}`}>
      Email the group helpdesk
    </a>
  );
}
